import axios from 'axios'
import {
  GET_CUST_DETAILS_URL,
  GET_CUST_DEBT_URL,
  UPDATE_CUSTOMER_DETAILS_URL,
  GET_BANNER_MESSAGES_URL,
  POST_PROCESS_BANNER_INTERACTION_URL,
  POST_UPDATE_TECH_INSTALL_NOTES_URL
} from '../constants/urls'
import { createRedirectError, getApiErrorMessage } from '../utils/error'
import { stringifyQueryString } from '../utils/navigation'
import { TECH_INSTALL_NOTES_NEWLINE_REGEX, EMPTY_STRING, SPACE } from '../constants/configuration'

export async function getCustomer({ fxbuyflowSessionId, sourceSystem }) {
  try {
    const { data } = await axios.post(GET_CUST_DETAILS_URL, {
      fxbuyflowSessionId
    })
    return data
  } catch (error) {
    throw createRedirectError(error, sourceSystem)
  }
}

export async function getCustomerDebt(sessionId) {
  const { data: res } = await axios.get(`${GET_CUST_DEBT_URL}/${sessionId}`)
  return res.data
}

export async function getBannerMessages() {
  try {
    const { data: res } = await axios.get(GET_BANNER_MESSAGES_URL)
    return res
  } catch {
    return null
  }
}

export async function processBannerInteraction(payload) {
  try {
    const { data: res } = await axios.post
    (POST_PROCESS_BANNER_INTERACTION_URL, payload)
    return res
  }
  catch {
    return null
  }
}

export async function updateCustomerInfo(
  payload,
  { opportunityId, sessionId, fxbuyflowSessionId }
) {
  const queryString = stringifyQueryString({
    opportunityId,
    sessionId,
    fxbuyflowSessionId
  })
  const { billingAddress } = payload
  const { phone, mobilePhone, ...updatedBillingAddress } = billingAddress
  const updatedPayload = {
    ...payload,
    billingAddress: updatedBillingAddress,
    phone,
    mobilePhone: mobilePhone || null
  }

  try {
    const { isMobileNumberUpdateToggleEnabled } = payload
    const payloadToSend = isMobileNumberUpdateToggleEnabled ? updatedPayload :
      payload
    await axios.post(`${UPDATE_CUSTOMER_DETAILS_URL}?${queryString}`, payloadToSend)
    return true
  } catch (err) {
    const errorMsg = getApiErrorMessage(err)
    throw new Error(errorMsg?.description)
  }
}

export async function updateTechInstallNotes(notes, sessionData) {
  try {
    const { opportunityId } = sessionData
    const updatedNotes = (notes ?? EMPTY_STRING).
      replace(TECH_INSTALL_NOTES_NEWLINE_REGEX, SPACE)
    const { data: res } = await axios.post(
      `${POST_UPDATE_TECH_INSTALL_NOTES_URL}`,
      { techInstallNotes: updatedNotes.trim(),
        opportunityid: opportunityId }
    )
    return res
  } catch (error) {
    return null
  }
}
